import { cn } from '~/shared/lib/cn'
import { SkeletonBlock } from '~/shared/ui/skeleton-block'

export function LoadingSkeleton({
  variant = 'page',
  initialFitToWidth = false,
}: {
  variant?: 'page' | 'document'
  initialFitToWidth?: boolean
}) {
  return (
    <div
      className={cn('h-full w-full', {
        'px-[66px] py-3': variant === 'page',
        'px-3': variant === 'page' && initialFitToWidth,
      })}
    >
      <div
        className={cn('bg-surface-lowest h-full w-full', {
          'aspect-[calc(1/1.2925)]': variant === 'page',
        })}
      >
        <SkeletonBlock className="h-full w-full rounded-none" />
      </div>
    </div>
  )
}
